<template>
  <section>
    <!-- 统计文字 -->
    <el-row style="padding:15px;background:#fff">
      <el-col >
        <el-row :gutter="10">
        	<el-select size="small" v-model="chooseProduct.name" clearable filterable  placeholder="请输入/选择小程序名称" @clear="clear('issued_app_id')" >
					    <el-option
					      v-for="item in IssAppList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id"
					      @click.native="changeProduct(item)"
					     
					      default-first-option
					    ></el-option>
				  </el-select>
          <el-select style="width:150px;" size="small" v-model="pdata.channel_id" clearable filterable   placeholder="请选择对应公司/渠道"  @clear="clear('channel_id')">
              <el-option v-for="item,index in companys_chiannelList" :key="item.channel_id" :label="item.company+'-'+item.ald_channel" :value="item.channel_id"></el-option>
          </el-select>
          <el-select style="width:150px;" size="small" v-model="pdata.uid" clearable filterable   placeholder="请选择操作人员"  @clear="clear('uid')">
              <el-option key="" label="请选择操作人员" value=""  v-if="pdata.uid==''"></el-option>
              <el-option v-for="item,index in users" :key="item.uid" :label="item.username" :value="item.uid"></el-option>
          </el-select>
        </el-row>
      </el-col>
      <!--<el-col :sm="8" :xs="24">
        <div style="float:right;text-align: right;">
          <el-row :gutter="10">
            <searchApp  class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>
          </el-row>
        </div>
      </el-col>-->
    </el-row>

    <el-table :data="list" style="width: 100%;min-width:1200px" stripe row-key="id" >
    	<el-table-column prop="name" label="游戏名称" align="center" width="125px"></el-table-column>
      <el-table-column prop="company" label="对应公司" align="center" width="125px"></el-table-column>
      <el-table-column prop="ald_channel" label="渠道名称" align="center" width="125px"></el-table-column>
      <el-table-column prop="username" label="操作人员" align="center" ></el-table-column>
	  	<el-table-column prop="create_time" label="操作时间" align="center" min-width="185px"></el-table-column>
	  	<el-table-column prop="content" label="备忘" align="center" min-width="185px"></el-table-column>
	 
	  	
    </el-table>

    <el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>


  </section>
</template>

<script>
import { getLogCost, getAppid,getIssuedAppList,selectCompany,getIssuedAldChanneList,selectUser,selectC} from "../../api/api";

export default {
  data() {
    return {
      chartColumn: null,
      pholder: "",
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_id: "",
        kw: "",
        channel_id:'',
        company:'',
        uid:'',
        
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-15",
        // edate: "2019-04-15",
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},
//    companys:[],
      IssAppList:[],
//    ChannelList:[],
      users:[],
      companys_chiannelList:[],

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 7 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      list:[], //所有数据
      chooseProduct:{},
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    },
    'pdata.issued_app_id': {
      handler(n, o) {
        this.getList();
      
      },
      deep: true
    },
    'pdata.company': {
      handler(n, o) {
      
      	this.getList();
       
      },
      deep: true
    },
    'pdata.channel_id':{
    	 handler(n, o) {
      	this.getList();
       
      },
      deep: true
    },
    'pdata.uid':{
    	 handler(n, o) {
      	this.getList();
       
      },
      deep: true
    }
  },
  methods: {
  	 clear(str){
  		 switch(str){
  		 	case 'issued_app_id' : this.pdata.issued_app_id='';
  		 	break;
  		 	case 'company' : this.pdata.company='';
  		 	break;
  		 	case 'channel_id' : this.pdata.channel_id='';
  		 	break;
  		 	case 'uid':this.pdata.uid='';
  		 	break;
  		 	
  		 }
  	 },
  	 getSummaries(param) {
	    const { columns, data } = param;
	    const sums = [];
	    columns.forEach((column, index) => {
	      if (index === 0) {
	        sums[index] = '合计';
	        return;
	      }
	      else if(index === 3){
	      	
	      	 sums[index] = 'N/A';
	      	 return;
	      }

	     
	      const values = data.map(item => Number(item[column.property]));
	      if (!values.every(value => isNaN(value))) {
	        sums[index] = values.reduce((prev, curr) => {
	          const value = Number(curr);
	          if (!isNaN(value)) {
	            return prev + curr;
	          } else {
	            return prev;
	          }
	        }, 0);
	        sums[index] = sums[index].toFixed(2)  ;
	      } else {
	        sums[index] = 'N/A';
	      }
	    });
	
	    return sums;
	  },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getLogCost(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
          if(res.data.list&&res.data.list.length>0){
          	this.list=res.data.list;
          	this.maxPage=res.data.max_page;
          }
          else{
          		this.list=[];
          }
          
          
        }
      });
//    selectCompany(p, this.$cookie.getCookie("login")).then(res => {
//      if (res.code == 200) {
//      	
//        if(res.data&&res.data.length>0){
//	            this.companys=res.data;
//        }
//        else{
//        		this.companys=[];
//        }
//        
//        
//      }
//    });
      selectUser(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	
          if(res.data&&res.data.length>0){
	            this.users=res.data;
          }
          else{
          		this.users=[];
          }
          
          
        }
      });
//   getIssuedAldChanneList(p, this.$cookie.getCookie("login")).then(res => {
//
//      if (res.code == 200) {
//      
//      	
//        if(res.data.list&&res.data.list.length>0){
//	            this.ChannelList=res.data.list;
//        }
//        else{
//        		this.ChannelList=[];
//        }
//        
//        
//      }
//    });
    },
   	getIssAPPList(){
			var p="";
			getIssuedAppList(p, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.IssAppList = res.data;
	          this.IssAppList.forEach((v,i)=>{
	          	if(v.id==this.pdata.issued_app_id ){
	          		this.chooseProduct.name=v.name;
	          	}
	          })
	        }
	      });
	    selectC(p, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	        
	          if(res.data&&res.data.length>0){
	            this.companys_chiannelList=res.data;
          }
          else{
          		this.companys_chiannelList=[];
          }
	          
	        }
	      });
		},

    changeProduct(res){
    	
	 	 this.pdata.issued_app_id=res.id;
			
	 	 
	 	 
	 },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    changeId(res) {
      this.pdata.issued_app_id = res;
      this.getList();
    }
  },

  mounted() {

    if (Object.keys(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
      this.pdata.app_id = this.$route.params.app_id;
      this.pholder = this.$route.params.name;
    }
    this.getList();
    this.getIssAPPList();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>


<style scoped="scoped">
	.red{
		color: #FF0000;
	}
</style>


// WEBPACK FOOTER //
// costLog.vue?5517c9b6